import * as React from "react";
import * as ReactDOM from "react-dom";

const AvatarEditorModal = React.lazy(() => import(/* webpackChunkName: "avatarEditor" */ './AvatarEditorModal'))

class AvatarEditor extends React.Component<{btn: any}> {
	render() {
		return <div>
			<React.Suspense fallback={<div>Loading...</div>}>
				<AvatarEditorModal btn={this.props.btn} />
			</React.Suspense>
		</div>;
	}
}

export default function Init(btn) {
	let content = document.getElementById("avatarEditorContent");

	if (!content) {
		content = document.createElement("div");
		content.id = "avatarEditorContent";
		document.body.appendChild(content);
		ReactDOM.render(<AvatarEditor btn={btn} />, content);
	}
}